import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { useStartCheckout } from './useStartCheckout';

export function useBasketDrawerCheckoutCta() {
  const showCheckoutCta = useFeatureIsOn('feature.basket-drawer-checkout-cta');
  const { startCheckout, isStartingCheckout } = useStartCheckout();

  return {
    showCheckoutCta,
    onCheckout: startCheckout,
    isCheckoutLoading: isStartingCheckout,
  };
}
